//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"FrontAngle",0,"Expression",0],[0,"FrontLoading",1,0],[1,"FrontObjects",0,"ScCollector",0],[0,"Position",1,0],[1,"RearAngle",0,"Expression",0],[0,"RearLoading",1,0],[1,"RearObjects",0,"ScCollector",0],[0,"RequirementsControl",1,0],[0,"ShowDistanceMeasurement",1,0],[0,"Standard",1,0],[0,"Visualization",1,0],[0,"WheelSize",1,0]],[],[]];
SPLM.Features.VehicleDesign.SlopeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.SlopeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.SlopeBuilder.RequirementsControlType = Object.freeze({
    "StandardDriven" : "StandardDriven", "UserDefined" : "UserDefined"});

SPLM.Features.VehicleDesign.SlopeBuilder.PositionType = Object.freeze({
    "Front" : "Front", "Rear" : "Rear", "Both" : "Both"});

SPLM.Features.VehicleDesign.SlopeBuilder.WheelSizeType = Object.freeze({
    "StaticRadius" : "StaticRadius", "Diameter" : "Diameter"});

SPLM.Features.VehicleDesign.SlopeBuilder.VisualizationType = Object.freeze({
    "Curve" : "Curve", "Surface" : "Surface", "CurveandSurface" : "CurveandSurface"});

export default SPLM;